import { render, staticRenderFns } from "./confirmar.vue?vue&type=template&id=a47b7d52&"
import script from "./confirmar.vue?vue&type=script&lang=js&"
export * from "./confirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports